import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 40px 0;
`;

const Container = styled.div.attrs({ className: 'app-container' })`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const NotFoundContainer = styled.div.attrs({ className: 'app-not-found-container' })`
  text-align: center;
  padding: 60px 0;
  max-width: 600px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 10rem;
  margin-bottom: 1rem;
  color: var(--accent-color);
  font-weight: 700;
  
  @media (max-width: 576px) {
    font-size: 6rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  
  @media (max-width: 576px) {
    font-size: 1.5rem;
  }
`;

const Description = styled.p`
  margin-bottom: 2rem;
  font-size: 1.1rem;
`;

const HomeButton = styled(Link)`
  display: inline-block;
  background-color: var(--accent-color);
  color: var(--primary-color);
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #c89a3e;
    transform: translateY(-2px);
    text-decoration: none;
  }
`;

const NotFoundPage = () => {
  return (
    <PageContainer>
      <Container>
        <NotFoundContainer>
          <Title>404</Title>
          <Subtitle>Page Not Found</Subtitle>
          <Description>
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </Description>
          <HomeButton to="/">Return to Home</HomeButton>
        </NotFoundContainer>
      </Container>
    </PageContainer>
  );
};

export default NotFoundPage; 